import { BaseFooter, Footer } from "@product/scmp-sdk";
import { memo } from "react";
import type { FunctionComponent } from "react";

import { Portal } from "~/components/common/portal";
import { useNewsletterWidget } from "~/components/newsletter/newsletter-widget-container/hooks";
import { FooterElementID } from "~/pages/_app/consts";

import { DynamicHomeFooter, DynamicPostiesFooter, DynamicStyleFooter } from "./dynamics";
import type { ContainerProps } from "./styles";
import { Container } from "./styles";

export type FooterVariant = "posties" | "magazines-style" | "home";

export type Props = {
  className?: string;
  hasPrintEditionFooter?: boolean;
  variant?: ContainerProps["$variant"];
};

const AppFooter_: FunctionComponent<Props> = ({ className, hasPrintEditionFooter, variant }) => {
  const { dataMatrix } = useNewsletterWidget({
    contentType: "footer",
    eventCategory: "Newsletter (Footer - Inline)",
    section: "",
  });

  const renderFooter = () => {
    switch (variant) {
      case "posties":
        return <DynamicPostiesFooter />;
      case "magazines-style":
        return <DynamicStyleFooter />;
      case "home":
        return <DynamicHomeFooter />;

      default:
        return (
          <BaseFooter
            dataMatrix={dataMatrix}
            newsletterItems={[]}
            queryParametersForSocialButtons={queryParametersForSocialButtons}
          />
        );
    }
  };

  const queryParametersForSocialButtons = {};
  return (
    <Portal selector={`#${FooterElementID}`}>
      <Container $variant={variant} className={className}>
        {hasPrintEditionFooter ? (
          <Footer
            dataMatrix={dataMatrix}
            queryParametersForSocialButtons={queryParametersForSocialButtons}
          />
        ) : (
          renderFooter()
        )}
      </Container>
    </Portal>
  );
};

export const AppFooter = memo(AppFooter_);

AppFooter.displayName = "AppFooter";
